import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import './../../styles/admin/clientes_edit.css';
import * as globals from './../../components/GlobalScripts.js';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useParams, Link, useNavigate } from 'react-router-dom';

const containerStyle = {
    width: '100%',
    height: '400px'
};

const defaultCenter = {
    lat: -0.180653,
    lng: -78.467834
};

function money(n) {
    const x = Number(n || 0);
    return x.toFixed(2);
}

function dt(s) {
    if (!s) return '—';
    return String(s).slice(0, 19).replace('T', ' ');
}

function TicketIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V7Z" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
            <path d="M9 8v8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
    );
}

function SearchIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" fill="none" stroke="currentColor" strokeWidth="2.2" />
            <path d="M16.5 16.5 21 21" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
    );
}

function XIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
    );
}

function RefreshIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20 12a8 8 0 1 1-2.35-5.65" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <path d="M20 4v6h-6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function TrashIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 7h16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <path d="M10 11v6M14 11v6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <path d="M6 7l1 14h10l1-14" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
            <path d="M9 7V4h6v3" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        </svg>
    );
}

function discountLabel(c) {
    if (!c) return '';
    const tipo = String(c.tipo_descuento || '');
    const valor = Number(c.valor || 0);

    if (tipo === 'percent') return `${valor}% OFF`;
    if (tipo === 'fixed') return `$${money(valor)} OFF`;
    return '';
}

function safeItems(res) {
    const d = res?.data || {};
    if (Array.isArray(d.items)) return d.items;
    if (Array.isArray(d.cupones)) return d.cupones;
    if (Array.isArray(d.rows)) return d.rows;
    return [];
}

function normalizePaging(p, fallbackPage = 1, fallbackItemsPerPage = 12) {
    const page = Number(p?.page || fallbackPage || 1);
    const total = Number(p?.total || 0);

    const total_pages =
        Number(p?.total_pages || 0) ||
        Number(p?.pages || 0) ||
        Number(p?.totalPages || 0) ||
        1;

    const itemsPerPage =
        Number(p?.itemsPerPage || 0) ||
        Number(p?.limit || 0) ||
        fallbackItemsPerPage;

    return {
        page: page < 1 ? 1 : page,
        total: total < 0 ? 0 : total,
        total_pages: total_pages < 1 ? 1 : total_pages,
        itemsPerPage: itemsPerPage < 1 ? fallbackItemsPerPage : itemsPerPage,
    };
}

const Admin_clientes_edit = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id } = useParams();

    const [user, setUser] = useState({});
    const [formDataUserDelivery, setFormDataUserDelivery] = useState({});
    const [formDataAddress, setFormDataAddress] = useState({});

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBYnh7Tl6Z724ZL3Z_VqCgrUVKPSwGE7l4',
    });

    const apiPayloadBase = useMemo(() => ({
        rute: globals.getRuteBackend(),
        session_id: globals.get_session_id(),
        keylogin: globals.get_keylogin(),
    }), []);

    const [couponQ, setCouponQ] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponResults, setCouponResults] = useState([]);
    const [couponPaging, setCouponPaging] = useState({ page: 1, total_pages: 1, total: 0, itemsPerPage: 10 });
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [couponNote, setCouponNote] = useState('');
    const [couponOpenResults, setCouponOpenResults] = useState(false);
    const couponDebounceRef = useRef(null);

    const [myCouponsLoading, setMyCouponsLoading] = useState(false);
    const [myAssigned, setMyAssigned] = useState([]);
    const [myAvailable, setMyAvailable] = useState([]);

    const [niveles, setNiveles] = useState([]);

    const fetchNiveles = async () => {
        try {
            const res = await axios.post(`${path_api}/default/niveles.php`, {
                rute: globals.getRuteBackend(),
            });
            if (res.data?.mensaje === 'success') setNiveles(res.data?.niveles || []);
        } catch { }
    };

    useEffect(() => {
        fetchNiveles();
    }, []);

    const fetchCoupons = async ({ page = 1 } = {}) => {
        setCouponLoading(true);
        try {
            const res = await axios.post(`${path_api}/admin/cupones/list.php`, {
                ...apiPayloadBase,
                page,
                itemsPerPage: couponPaging.itemsPerPage,
                q: String(couponQ || '').trim(),
                activo: 1,
            });

            if (res.data?.mensaje === 'success') {
                setCouponResults(safeItems(res));
                const p = res.data?.paging || res.data?.pagination || null;
                if (p) setCouponPaging(normalizePaging(p, page, couponPaging.itemsPerPage));
                else setCouponPaging((prev) => ({ ...prev, page }));
                return;
            }

            setCouponResults([]);
        } catch {
            setCouponResults([]);
        } finally {
            setCouponLoading(false);
        }
    };

    const handleAssignCouponToClient = async () => {
        if (!selectedCoupon?.id) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Selecciona un cupón primero.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
            return;
        }

        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/admin/cupones/assign.php`, {
                ...apiPayloadBase,
                cupon_id: Number(selectedCoupon.id),
                keylogins: [String(id)],
                nota: String(couponNote || '').trim() || null,
            });

            if (res.data?.mensaje === 'success') {
                const inserted = Number(res.data?.inserted || 0);

                globals.createAlert({
                    type: "success",
                    msg_title: "Asignado",
                    msg: inserted > 0
                        ? `Cupón asignado al cliente (${id}).`
                        : `El cupón ya estaba asignado (se reactivó si estaba inactivo).`,
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4200
                });

                setSelectedCoupon(null);
                setCouponNote('');
                setCouponQ('');
                setCouponResults([]);
                setCouponOpenResults(false);

                fetchRedemptions({ page: 1 });
                await fetchClientCoupons();
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo asignar el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al asignar el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
        }
    };

    const handleUnassignCouponFromClient = async (cupon) => {
        const cupon_id = Number(cupon?.id || 0);
        if (!cupon_id) return;

        const code = cupon?.codigo || `#${cupon_id}`;
        const ok = window.confirm(`¿Quitar el cupón ${code} de este cliente?\n\nEsto lo desactiva para el cliente, no borra el cupón.`);
        if (!ok) return;

        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/admin/cupones/unassign.php`, {
                ...apiPayloadBase,
                cupon_id,
                cliente_keylogin: String(id),
            });

            if (res.data?.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Listo",
                    msg: "Cupón removido del cliente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4200
                });

                await fetchClientCoupons?.();
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo remover el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al remover el cupón.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
        }
    };

    const fetchClientCoupons = async () => {
        if (!id) return;

        setMyCouponsLoading(true);

        try {
            let res = null;

            try {
                res = await axios.post(`${path_api}/default/cupones/mis_cupones.php`, {
                    ...apiPayloadBase,
                    cliente_keylogin: String(id),
                });
            } catch {
            }

            if (res?.data?.mensaje === 'success') {
                const asignados = Array.isArray(res.data.asignados) ? res.data.asignados : (Array.isArray(res.data.items) ? res.data.items : []);
                const disponibles = Array.isArray(res.data.disponibles) ? res.data.disponibles : [];

                setMyAssigned(asignados);
                setMyAvailable(disponibles);
                return;
            }

            setMyAssigned([]);
            setMyAvailable([]);
        } finally {
            setMyCouponsLoading(false);
        }
    };

    const [redLoading, setRedLoading] = useState(false);
    const [redItems, setRedItems] = useState([]);
    const [redPaging, setRedPaging] = useState({ page: 1, total_pages: 1, total: 0, itemsPerPage: 10 });
    const [redPage, setRedPage] = useState(1);

    const fetchRedemptions = async ({ page: nextPage = 1 } = {}) => {
        setRedLoading(true);
        globals.openViewCharge();

        try {
            const res = await axios.post(`${path_api}/admin/cupones/redenciones.php`, {
                ...apiPayloadBase,
                q: String(id || '').trim(),
                page: nextPage,
                itemsPerPage: redPaging.itemsPerPage,
                limit: redPaging.itemsPerPage,
            });

            if (res.data?.mensaje === 'success') {
                const items = Array.isArray(res.data?.items) ? res.data.items : [];
                setRedItems(items);

                const p = res.data?.paging || res.data?.pagination || null;
                if (p) {
                    const normalized = normalizePaging(p, nextPage, redPaging.itemsPerPage);
                    setRedPaging(normalized);
                    setRedPage(normalized.page);
                } else {
                    setRedPaging((prev) => ({ ...prev, page: nextPage }));
                    setRedPage(nextPage);
                }
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudieron cargar redenciones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar redenciones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
            setRedLoading(false);
        }
    };

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            if (userParsed) setUser(userParsed);
        }

        get_user_delivery();
    }, []);

    useEffect(() => {
        if (!id) return;
        fetchRedemptions({ page: 1 });
        fetchClientCoupons();
    }, [id]);

    useEffect(() => {
        if (!couponOpenResults) return;

        if (couponDebounceRef.current) clearTimeout(couponDebounceRef.current);
        couponDebounceRef.current = setTimeout(() => {
            fetchCoupons({ page: 1 });
        }, 280);

        return () => {
            if (couponDebounceRef.current) clearTimeout(couponDebounceRef.current);
        };
    }, [couponOpenResults]);

    const get_user_delivery = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/get_user_delivery.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                response.data.user.nivel_descripcion = response.data.user.nivel.descripcion;
                response.data.user.nivel = response.data.user.nivel.id;
                setFormDataUserDelivery(response.data.user);
                setFormDataAddress(response.data.user.address);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el usuario",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(() => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el usuario",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        globals.openViewCharge();

        axios.post(`${path_api}/update-clients/update_client.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            cliente: id,
            nivel: formDataUserDelivery.nivel,
            envios: formDataUserDelivery.envios,
            rewardAvailable: formDataUserDelivery.rewardAvailable,
            envios_expira_at: formDataUserDelivery.envios_expira_at,
            referrer: formDataUserDelivery.referrer,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: 'success',
                    msg_title: 'Éxito',
                    msg: 'Cliente actualizado exitosamente.',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se actualizo el clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(() => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar el cliente",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataUserDelivery({ ...formDataUserDelivery, [name]: newValue });
    };

    const handleMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress(prev => ({ ...prev, lat, lng }));
    };

    const handleMarkerDragEnd = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setFormDataAddress(prev => ({ ...prev, lat, lng }));
    };

    const onFocusCouponSearch = () => {
        setCouponOpenResults(true);
        if (!couponResults.length && !couponLoading) fetchCoupons({ page: 1 });
    };

    const closeCouponResults = () => {
        setCouponOpenResults(false);
    };

    const currentMembership = useMemo(() => {
        const nid = String(formDataUserDelivery?.nivel || '');
        return niveles.find((n) => String(n?.id) === nid) || null;
    }, [niveles, formDataUserDelivery?.nivel]);

    const transferSubtotal = useMemo(() => {
        const raw = currentMembership?.precio_label ?? currentMembership?.precio;
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : null;
    }, [currentMembership]);

    const handleRedeemCouponTransfer = async () => {
        if (!selectedCoupon?.id) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Selecciona un cupón primero.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
            return;
        }

        if (!transferSubtotal) {
            globals.createAlert({
                type: "error",
                msg_title: "Falta subtotal",
                msg: "No pude determinar el subtotal por transferencia del plan actual. Revisa niveles/precio_label.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4500
            });
            return;
        }

        const clienteNombre = `${formDataUserDelivery?.account?.nombre || ''} ${formDataUserDelivery?.account?.apellidos || ''}`.trim() || `Cliente ${id}`;
        const code = selectedCoupon?.codigo || `#${selectedCoupon?.id}`;
        const planTxt = currentMembership?.descripcion || `Nivel ${formDataUserDelivery?.nivel}`;

        const ok = window.confirm(
            `¿Generar remisión por transferencia?\n\n` +
            `Cliente: ${clienteNombre}\n` +
            `Cupón: ${code}\n` +
            `Plan: ${planTxt}\n` +
            `Subtotal (transfer): $${money(transferSubtotal)} USD\n\n` +
            `Esto registrará una redención y desactivará el cupón para este cliente.`
        );

        if (!ok) return;

        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/admin/cupones/redeem_transfer.php`, {
                ...apiPayloadBase,
                cliente_keylogin: String(id),
                cupon_id: Number(selectedCoupon.id),
                membership_id: Number(formDataUserDelivery?.nivel || 0) || null,
                subtotal: Number(transferSubtotal),
                moneda: "USD",
                nota: String(couponNote || '').trim() || null,
            });

            if (res.data?.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Listo",
                    msg: `Redención creada. Total: $${money(res.data?.calc?.total_final)} ${res.data?.calc?.moneda || 'USD'}`,
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4200
                });

                setSelectedCoupon(null);
                setCouponNote('');
                setCouponQ('');
                setCouponResults([]);
                setCouponOpenResults(false);

                await fetchClientCoupons();
                fetchRedemptions({ page: 1 });
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudo generar la redención.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al generar la redención por transferencia.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
        }
    };


    return (
        <>
            <div className='page-clientes-edit container-section small-section flex-column gap-20'>
                <form onSubmit={handleSubmit} className="flex-column gap-20">
                    <Link to="/admin/clientes" className="flex-row gap-5">
                        <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662" fill="var(--color-primary)" stroke="var(--color-primary)" strokeWidth="6" />
                        </svg>
                        <h4 style={{ color: "var(--color-primary)" }}>Volver</h4>
                    </Link>

                    <h3>Cliente</h3>

                    <div className='user-delivery'>
                        <p className='text-green'>Nivel {formDataUserDelivery.nivel}: {formDataUserDelivery?.nivel_descripcion}</p>

                        <div className="form-grop-row">
                            <div className="form-group">
                                <label htmlFor="nivel" className='required'>Nivel</label>
                                <input
                                    type="number"
                                    id="nivel"
                                    name="nivel"
                                    value={formDataUserDelivery.nivel}
                                    onChange={handleChange}
                                    className="input-primary"
                                    required
                                    min="1"
                                    max="3"
                                    onKeyDown={(e) => {
                                        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                        if (allowedKeys.includes(e.key)) return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="envios" className='required'>Envios</label>
                                <input
                                    type="number"
                                    id="envios"
                                    name="envios"
                                    value={formDataUserDelivery.envios}
                                    onChange={handleChange}
                                    className="input-primary"
                                    required
                                    min="0"
                                    max="200"
                                    onKeyDown={(e) => {
                                        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                        if (allowedKeys.includes(e.key)) return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="rewardAvailable" className='required'>Recompensas</label>
                                <input
                                    type="number"
                                    id="rewardAvailable"
                                    name="rewardAvailable"
                                    value={formDataUserDelivery.rewardAvailable}
                                    onChange={handleChange}
                                    className="input-primary"
                                    required
                                    min="0"
                                    max="100"
                                    onKeyDown={(e) => {
                                        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                        if (allowedKeys.includes(e.key)) return;
                                        if (!/^\d$/.test(e.key)) e.preventDefault();
                                    }}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="envios_expira_at" className='required'>Expiración de envios</label>
                            <input
                                type="datetime-local"
                                id="envios_expira_at"
                                name="envios_expira_at"
                                value={formDataUserDelivery.envios_expira_at}
                                onChange={handleChange}
                                className="input-primary"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="referrer">Referente</label>
                            <input
                                type="text"
                                id="referrer"
                                name="referrer"
                                value={formDataUserDelivery.referrer}
                                onChange={handleChange}
                                className="input-primary"
                            />
                        </div>

                        <p><b>Keylogin:</b> {id}</p>
                        <p><b>Nombre:</b> {formDataUserDelivery?.account?.nombre} {formDataUserDelivery?.account?.apellidos}</p>
                        <p><b>Telefono:</b> {formDataUserDelivery?.account?.phone}</p>
                        <p><b>Email:</b> {formDataUserDelivery?.account?.email}</p>
                        <p><b>Fecha de nacimiento:</b> {formDataUserDelivery?.account?.birthday ?? 'No especificado'}</p>

                        {isLoaded && (
                            <div className="map-container">
                                <h5><b>Direccion:</b></h5>
                                <p>{formDataAddress?.direccion}, {formDataAddress?.colonia}, {formDataAddress?.ciudad}, {formDataAddress?.estado}, {formDataAddress?.cp}</p>
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={{
                                        lat: formDataAddress?.lat || defaultCenter.lat,
                                        lng: formDataAddress?.lng || defaultCenter.lng
                                    }}
                                    zoom={14}
                                    onClick={handleMapClick}
                                    options={{
                                        zoomControl: true,
                                        zoomControlOptions: {
                                            position: window.google && window.google.maps ? window.google.maps.ControlPosition.RIGHT_CENTER : undefined
                                        }
                                    }}
                                >
                                    {formDataAddress?.lat && formDataAddress?.lng && (
                                        <Marker
                                            position={{ lat: formDataAddress.lat, lng: formDataAddress.lng }}
                                            draggable={true}
                                            onDragEnd={handleMarkerDragEnd}
                                        />
                                    )}
                                </GoogleMap>
                                <p><b>Apartamento:</b> {formDataAddress?.apartamento}</p>
                                <p><b>Referencia:</b> {formDataAddress?.referencia}</p>
                                <p><b>Comentarios:</b><br />{formDataAddress?.comentarios}</p>
                            </div>
                        )}
                    </div>

                    <div className="buttons-opt">
                        <button className="button-primary" type="submit">
                            Actualizar
                        </button>
                    </div>
                </form>
            </div>

            <div className='page-clientes-edit container-section  medium-section flex-column gap-20'>
                <div className="cliente-card">
                    <div className="cliente-card__head">
                        <div className="cliente-card__title">
                            <span className="cliente-card__icon" aria-hidden="true"><TicketIcon /></span>
                            Cupones del cliente
                        </div>

                        <button
                            type="button"
                            className="cliente-iconbtn"
                            title="Actualizar cupones"
                            onClick={fetchClientCoupons}
                            disabled={myCouponsLoading}
                        >
                            <RefreshIcon />
                        </button>
                    </div>

                    <div className="cliente-coupons-grid">
                        <div className="cliente-coupons-col">
                            <div className="cliente-coupons-subtitle">
                                Asignados <span className="cliente-pill">{myAssigned.length}</span>
                            </div>

                            {myCouponsLoading && <div className="cliente-coupons-empty">Cargando…</div>}

                            {!myCouponsLoading && myAssigned.length === 0 && (
                                <div className="cliente-coupons-empty">No tiene cupones asignados.</div>
                            )}

                            {!myCouponsLoading && myAssigned.map((c) => (
                                <div key={`a-${c.id}`} className="cliente-coupon-row">
                                    <div className="cliente-coupon-main">
                                        <div className="cliente-coupon-code">{c.codigo || `#${c.id}`}</div>
                                        <div className="cliente-coupon-title">{c.titulo || c.descripcion || '—'}</div>

                                        <div className="cliente-coupon-meta">
                                            <span className="cliente-coupon-pill">{discountLabel(c)}</span>
                                            {c.expira_at
                                                ? <span className="cliente-coupon-dim">Expira: {dt(c.expira_at)}</span>
                                                : <span className="cliente-coupon-dim">Sin expiración</span>}
                                        </div>

                                        {c.nota ? <div className="cliente-coupon-note">Nota: {c.nota}</div> : null}
                                    </div>

                                    <div className="cliente-coupon-actions">
                                        <button
                                            type="button"
                                            className="cliente-coupon-btn danger"
                                            title="Quitar cupón del cliente"
                                            onClick={() => handleUnassignCouponFromClient(c)}
                                        >
                                            <TrashIcon />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="cliente-coupons-col">
                            <div className="cliente-coupons-subtitle">
                                Disponibles <span className="cliente-pill">{myAvailable.length}</span>
                            </div>

                            {myCouponsLoading && <div className="cliente-coupons-empty">Cargando…</div>}

                            {!myCouponsLoading && myAvailable.length === 0 && (
                                <div className="cliente-coupons-empty">No hay cupones generales disponibles.</div>
                            )}

                            {!myCouponsLoading && myAvailable.map((c) => (
                                <button
                                    key={`d-${c.id}`}
                                    type="button"
                                    className="cliente-coupon-row clickable"
                                    onClick={() => {
                                        setSelectedCoupon(c);
                                        setCouponOpenResults(false);
                                    }}
                                    title="Seleccionar para asignar"
                                >
                                    <div className="cliente-coupon-main">
                                        <div className="cliente-coupon-code">{c.codigo || `#${c.id}`}</div>
                                        <div className="cliente-coupon-title">{c.titulo || c.descripcion || '—'}</div>
                                        <div className="cliente-coupon-meta">
                                            <span className="cliente-coupon-pill">{discountLabel(c)}</span>
                                            {c.expira_at ? <span className="cliente-coupon-dim">Expira: {dt(c.expira_at)}</span> : <span className="cliente-coupon-dim">Sin expiración</span>}
                                        </div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className='page-clientes-edit container-section medium-section flex-column gap-20'>
                <div className="cliente-card">
                    <div className="cliente-card__head">
                        <div className="cliente-card__title">
                            <span className="cliente-card__icon" aria-hidden="true"><TicketIcon /></span>
                            Buscar cupón
                        </div>

                        <button
                            type="button"
                            className="cliente-iconbtn"
                            title="Cerrar resultados"
                            onClick={closeCouponResults}
                            disabled={!couponOpenResults}
                        >
                            <XIcon />
                        </button>
                    </div>

                    {selectedCoupon ? (
                        <div className="cliente-selected">
                            <div className="cliente-selected__main">
                                <div className="cliente-selected__code">{selectedCoupon.codigo || `#${selectedCoupon.id}`}</div>
                                <div className="cliente-selected__meta">
                                    <div className="cliente-selected__title">{selectedCoupon.titulo || '—'}</div>
                                    <div className="cliente-selected__pill">{discountLabel(selectedCoupon)}</div>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="cliente-chipbtn"
                                onClick={() => setSelectedCoupon(null)}
                                title="Quitar selección"
                            >
                                <XIcon />
                            </button>
                        </div>
                    ) : (
                        <>
                            <div className="cliente-search">
                                <span className="cliente-search__ico" aria-hidden="true"><SearchIcon /></span>
                                <input
                                    className="input-primary cliente-search__input"
                                    placeholder="Buscar cupón por código o título…"
                                    value={couponQ}
                                    onChange={(e) => setCouponQ(e.target.value)}
                                    onFocus={onFocusCouponSearch}
                                />
                                <button
                                    type="button"
                                    className="cliente-mini-btn"
                                    onClick={() => fetchCoupons({ page: 1 })}
                                    disabled={couponLoading}
                                    title="Buscar"
                                >
                                    Buscar
                                </button>
                            </div>

                            {couponOpenResults && (
                                <div className="cliente-results">
                                    {couponLoading && <div className="cliente-results__empty">Buscando…</div>}

                                    {!couponLoading && couponResults.length === 0 && (
                                        <div className="cliente-results__empty">Sin resultados.</div>
                                    )}

                                    {!couponLoading && couponResults.map((c) => (
                                        <button
                                            key={c.id}
                                            type="button"
                                            className="cliente-result"
                                            onClick={() => {
                                                setSelectedCoupon(c);
                                                setCouponOpenResults(false);
                                            }}
                                        >
                                            <div className="cliente-result__left">
                                                <div className="cliente-result__code">{c.codigo || `#${c.id}`}</div>
                                                <div className="cliente-result__title">{c.titulo || c.descripcion || '—'}</div>
                                            </div>
                                            <div className="cliente-result__right">
                                                <span className="cliente-result__pill">{discountLabel(c)}</span>
                                            </div>
                                        </button>
                                    ))}

                                    <div className="cliente-results__pager">
                                        <button
                                            type="button"
                                            className="cliente-mini-btn ghost"
                                            onClick={() => fetchCoupons({ page: Math.max(1, couponPaging.page - 1) })}
                                            disabled={couponLoading || couponPaging.page <= 1}
                                        >
                                            Anterior
                                        </button>

                                        <div className="cliente-results__meta">
                                            <b>{couponPaging.page}</b> / {couponPaging.total_pages} · <b>{couponPaging.total}</b> total
                                        </div>

                                        <button
                                            type="button"
                                            className="cliente-mini-btn ghost"
                                            onClick={() => fetchCoupons({ page: Math.min(couponPaging.total_pages || 1, couponPaging.page + 1) })}
                                            disabled={couponLoading || couponPaging.page >= (couponPaging.total_pages || 1)}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    <div className="form-group">
                        <label>Nota</label>
                        <input
                            className="input-primary"
                            value={couponNote}
                            onChange={(e) => setCouponNote(e.target.value)}
                            placeholder="Ej: Cupón de cumpleaños / Compensación / Campaña…"
                        />
                    </div>

                    <div className="cliente-actions cliente-actions--dual">
                        <button
                            type="button"
                            className="button-primary"
                            onClick={handleAssignCouponToClient}
                            disabled={!selectedCoupon?.id}
                        >
                            <TicketIcon />
                            Asignar a este cliente
                        </button>

                        <button
                            type="button"
                            className="button-primary outline"
                            onClick={handleRedeemCouponTransfer}
                            disabled={!selectedCoupon?.id}
                            title="Genera redención manual por transferencia y desactiva el cupón para el cliente"
                        >
                            <TicketIcon />
                            Remisión por transferencia
                        </button>
                    </div>
                </div>
            </div>

            <div className='page-clientes-edit container-section flex-column gap-20'>
                <div className="cliente-card">
                    <div className="cliente-card__head">
                        <div className="cliente-card__title">
                            <span className="cliente-card__icon" aria-hidden="true"><TicketIcon /></span>
                            Redenciones del cliente
                        </div>

                        <button
                            type="button"
                            className="cliente-iconbtn"
                            title="Actualizar redenciones"
                            onClick={() => fetchRedemptions({ page: 1 })}
                            disabled={redLoading}
                        >
                            <RefreshIcon />
                        </button>
                    </div>

                    <div className="cliente-red-table">
                        <div className="cliente-red-head">
                            <div>Fecha</div>
                            <div>Cupón</div>
                            <div>Subtotal</div>
                            <div>Descuento</div>
                            <div>Total</div>
                            <div>Payment</div>
                            <div>Plan</div>
                        </div>

                        {redLoading && <div className="cliente-red-empty">Cargando…</div>}

                        {!redLoading && redItems.length === 0 && (
                            <div className="cliente-red-empty">Sin redenciones.</div>
                        )}

                        {!redLoading && redItems.map((r) => (
                            <div key={r.id} className="cliente-red-row">
                                <div>{dt(r.created_at)}</div>
                                <div className="cliente-mono">{r.cupon_codigo || r.codigo || r.cupon_id || '—'}</div>
                                <div>${money(r.subtotal)} {r.moneda || 'USD'}</div>
                                <div>- ${money(r.descuento)}</div>
                                <div><b>${money(r.total_final)}</b></div>
                                <div className="cliente-mono">{r.payment_id || r.id_payment || '—'}</div>
                                <div>{r.membership_id || r.nivel || '—'}</div>
                            </div>
                        ))}
                    </div>

                    <div className="cliente-pager">
                        <button
                            type="button"
                            className="cliente-mini-btn ghost"
                            onClick={() => fetchRedemptions({ page: Math.max(1, redPage - 1) })}
                            disabled={redLoading || redPage <= 1}
                        >
                            Anterior
                        </button>

                        <div className="cliente-pager__meta">
                            <b>Página:</b> {redPaging.page} / {redPaging.total_pages} &nbsp;·&nbsp; <b>Total:</b> {redPaging.total}
                        </div>

                        <button
                            type="button"
                            className="cliente-mini-btn ghost"
                            onClick={() => fetchRedemptions({ page: Math.min(redPaging.total_pages || 1, redPage + 1) })}
                            disabled={redLoading || redPage >= (redPaging.total_pages || 1)}
                        >
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Admin_clientes_edit;
